const RESET_PAGE_MODES = ['resetPassword', 'revertSecondFactorAddition']
const RESET_PAGE_PATH = '/auth/resetpass'

/** Preserve Firebase action codes when the configured email URL lands on another auth page. */
export function firebaseActionTarget(pathname: string, search: string): string | null {
  if (pathname === RESET_PAGE_PATH) return null
  const params = new URLSearchParams(search)
  const mode = params.get('mode')
  if (!mode || !params.get('oobCode') || !RESET_PAGE_MODES.includes(mode)) return null
  return `${RESET_PAGE_PATH}?${params.toString()}`
}
